// extracted by mini-css-extract-plugin
module.exports = {"splitter":"BuildingsFilterMobile_splitter__KxW6G","actions":"BuildingsFilterMobile_actions__bY3Tq"};